<div class="d-flex justify-content-between">

  <div *ngIf='showParameter' class="part1">
    <div *ngIf="pickparamsURL == 'true'">
      <span class="input-group-btn">
        <mat-select class="selectOrder">
          <mat-select-trigger></mat-select-trigger>
          <mat-option *ngFor="let option of ParameterURL" [value]="option.viewValue"> {{option.value}} </mat-option>
        </mat-select>
      </span>
    </div>
    <div *ngIf="pickparamsvariants == 'true'">
      <span class="input-group-btnn">
        <mat-select class="selectOrder" (selectionChange)="addParameter($event)">
          <mat-select-trigger></mat-select-trigger>
          <mat-option *ngFor="let option of Parameter" [value]="option.viewValue"> {{option.value}} </mat-option>
        </mat-select>
      </span>
    </div>
    <div *ngIf='pickparamsprofile' class="ga_profile_parameter">
      <div class="AddChoix" style="margin-top: 11px;">
        <mat-select (selectionChange)="addParameter($event)" placeholder="Add parameter">
          <mat-select-trigger>Add parameter</mat-select-trigger>
          <mat-option *ngFor="let option of personolizedAlexa" [value]="option.viewValue"> {{option.value}}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div *ngIf="orderpickparamsprofile == 'true'" class="order">

      <div *ngIf="platform != 'woocommerce'" class="AddChoix" style="margin-top: 11px;">
        <mat-select (selectionChange)="addParameter($event)" placeholder="Add order parameter">
          <mat-select-trigger>Add order parameter </mat-select-trigger>
          <mat-option *ngFor="let option of Parameter" [value]="option.viewValue"> {{option.value}} </mat-option>
        </mat-select>
      </div>

      <div *ngIf="platform === 'woocommerce'" class="input-group-btn">
        <mat-select style="display: block" class="GA_param" (selectionChange)="addParameter($event)"
          placeholder="Add order parameter">
          <mat-select-trigger style="font-weight: bold!important; color: #5e5e5e!important;
        font-size: 13px;">Add order parameter</mat-select-trigger>
          <mat-option *ngFor="let option of woocommerceParameter" [value]="option.viewValue"> {{option.value}}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div *ngIf='showLength' class="part2">
      <div class="persono">
        <p *ngIf='showsize' [ngClass]="textMaxLen - textLen > 0 ? 'positive' : 'negative'">
          {{textLen}} / {{textMaxLen}}
        </p>
      </div>
    </div>
</div>

<div *ngIf='showem' class="emojistyle">
  <div cdkOverlayOrigin #emojiTrigger="cdkOverlayOrigin" class="emojistyle">
    <button class='mat-button' (click)="toggleEmojiPicker()">
      <i class="material-icons">tag_faces</i>
    </button>
  </div>
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="emojiTrigger" [cdkConnectedOverlayOpen]="showEmojis"
    [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
    (backdropClick)="showEmojis = false">
    <emoji-mart *ngIf='showEmojis' (emojiClick)="addEmoji($event)" set='facebook' emoji='' [showPreview]='false'
      [style]="{left:'100%',top:'7px'}"> </emoji-mart>
  </ng-template>
</div>
<!-- for email notifcations variants-->

<div *ngIf='pickparamsemailnotifications' class="row" class="emailN">
  <div class="parameterAudio">
    <mat-select class="emailNotif" placeholder="Add personalization" (selectionChange)="addParameter($event)">
      <mat-select-trigger style="    font-weight: bold!important;color: #303333;">Add
        personalization</mat-select-trigger>
      <mat-option *ngFor="let option of ParameterEmailNotifications" [value]="option.viewValue"> {{option.value}}
      </mat-option>
    </mat-select>

  </div>
</div>

<div *ngIf='pickparamsemailnotificationsCancelOrder' class="row" class="emailN">
  <div class="parameterAudio">
    <mat-select class="emailNotif" placeholder="Add personalization" (selectionChange)="addParameter($event)">
      <mat-select-trigger style="    font-weight: bold!important;color: #2f3030;">Add
        Personalization</mat-select-trigger>
      <mat-option *ngFor="let option of ParameterEmailNotificationsCancelOrder" [value]="option.viewValue">
        {{option.value}} </mat-option>
    </mat-select>

  </div>
</div>

<div *ngIf='pickparamsOrderevents' class="row" class="emailN">
  <span class="input-group-btn">
    <mat-select style="float: right; text-align : right; display: block;" class="selectOrder"
      (selectionChange)="addParameter($event)">
      <mat-select-trigger></mat-select-trigger>
      <mat-option *ngFor="let option of ParameterEvents" [value]="option.viewValue"> {{option.value}} </mat-option>
    </mat-select>
  </span>
</div>
<div *ngIf='showPersonolizationGreetingfb' class="part2 ">
  <mat-select placeholder="Add Personalization" floatlLabel="never" (selectionChange)=" addPersonolizedText($event)">
    <mat-select-trigger>Add Personalization</mat-select-trigger>
    <mat-option *ngFor="let option of personolizedGrettingFacebook" [value]="option.viewValue"> {{option.value}}
    </mat-option>
  </mat-select>

</div>

<div *ngIf='showPersonolization' class="part2" style="margin-top: 11px;">
  <div class="persono1">
    <span class="input-group-btn">
      <mat-select class="GA_param" placeholder="Add Personalization" (selectionChange)=" addPersonolizedText($event)">
        <mat-select-trigger>Add Personalization</mat-select-trigger>
        <mat-option *ngFor="let option of personolizedAlexa" [value]="option.viewValue"> {{option.value}} </mat-option>
      </mat-select>
    </span>
  </div>
</div>

<div *ngIf='showPersonolizationfB' class="part2" style="margin-top: 11px;">
  <div class="persono1">
    <span class="input-group-btn">
      <mat-select class="GA_param" placeholder="Add Personalization" (selectionChange)=" addPersonolizedText($event)">
        <mat-select-trigger>Add Personalization</mat-select-trigger>
        <mat-option *ngFor="let option of personolized" [value]="option.viewValue"> {{option.value}} </mat-option>
      </mat-select>
    </span>
  </div>
</div>